import {
  Component,
  Input,
  Output,
  OnChanges,
  ViewChild,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { InfoModalComponent } from '../../modal/info-modal/info-modal.component';
import { BaseModalComponent } from '../../modal/_base-modal.component';
import { AddEditUserFormComponent } from './add-edit-user-form/add-edit-user-form.component';
import { InviteUserService } from '../../invite-user/invite-user.service';
import { ProfileInfoService } from '../../profile/profile-info.service';
import { BrandService } from '../../brand/brand.service';

import * as _ from 'lodash';

@Component({
  moduleId: module.id,
  selector: 'add-edit-user-modal',
  templateUrl: 'add-edit-user-modal.component.html',
  styleUrls: ['add-edit-user-modal.component.scss'],
})
export class AddEditUserModalComponent extends BaseModalComponent implements OnChanges {

  userId: number;
  errMessage: string = '';

  user: any = {
    firstName: '',
    secondName: '',
    email: '',
    phone: '',
    isAdministrator: false,
    productCatalogView: false,
    damView: false,
    fitmentsView: false,
    repository: false,
    productCatalogEdit: false,
    damEdit: false,
    fitmentsEdit: false,
  };

  @Input() data: any;

  @Output() done  = new EventEmitter();
  @Output() inviteUserError  = new EventEmitter();

  @ViewChild('infoModal', {static: false}) infoModal: InfoModalComponent | void;

  @ViewChild(AddEditUserFormComponent, {static: false})
  addEditUserForm: AddEditUserFormComponent | void;

  constructor(
    private inviteUserService: InviteUserService,
    private profileInfoService: ProfileInfoService,
    private brandService: BrandService,
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  // getters

  get form(): UntypedFormGroup {
    return _.get(this.addEditUserForm, 'form');
  }

  get isActionsAvailable() {
    return this.addEditUserForm ? this.addEditUserForm.isFormValid : false;
  }

  get canSave() {

    if (this.form.controls['isAdministrator'].value) {    return true; }
    if (this.form.controls['productCatalogView'].value) { return true; }
    if (this.form.controls['productCatalogEdit'].value) { return true; }
    if (this.form.controls['damView'].value) {            return true; }
    if (this.form.controls['damEdit'].value) {            return true; }
    if (this.form.controls['fitmentsEdit'].value) {       return true; }
    if (this.form.controls['repository'].value) {         return true; }

    return false;
  }

  get sentInnerHtml() {
    return this.form ? `<p>
        <span class='color-darkgrey'>
          An email has been sent to</span>
        <span class='color-black'>
          ${this.form.get('email').value}
        </span>
      </p>`
      : '';
  }

  get sentPasswordResetHtml() {
    return this.form ? `<p>
        <span class='color-darkgrey'>
          An password reset has been sent to</span>
        <span class='color-black'>
          ${this.form.get('email').value}
        </span>
      </p>`
      : '';
  }

  get isPending(): boolean {
    return this.data ? this.data.last_accessed === 'Pending' : false;
  }

  get inviteUser() {
    if (this.data && this.data.user_id) {
      return false;
    }
    return true;
  }

  // hooks
  ngOnChanges() {
    if (!this.data) {
      this.data = this.user;
    }
  }

  // handlers
  onSendInviteClick() {
    if (!this.isActionsAvailable || !this.canSave) { return; }

    this.inviteUserService.send(this.brandService.getBrand(), this.addEditUserForm && this.addEditUserForm.formValue)
      .subscribe((res: any) => {
        this.done.emit();
        if (res.success) {
          if (this.infoModal instanceof InfoModalComponent) {
            this.infoModal.setData('Invite Sent!', this.sentInnerHtml);
            this.infoModal.show();
          }
          this.hide();
        } else {
          this.inviteUserError.emit();
        }
      });
  }

  onSendPasswordResetClick() {
    if (!this.isActionsAvailable) { return; }
    if (this.infoModal instanceof InfoModalComponent) {
      this.infoModal.setData('Password Reset Sent!', this.sentPasswordResetHtml);
      this.infoModal.show();
    }
    this.hide();
  }

  onSaveClick() {
    if (!this.canSave) { return; }
    this.profileInfoService.putPermissions(this.brandService.getBrand(), this.userId,
      this.addEditUserForm && this.addEditUserForm.formValue)
      .subscribe(res => {
        this.done.emit();
        if (this.infoModal instanceof InfoModalComponent) {
          this.infoModal.setData('User permissions were successfully saved!');
          this.infoModal.show();
        }

        this.hide();
    });
  }

  // public
  public hide() {
    super.hide();
    this.errMessage = '';
    if (this.addEditUserForm instanceof AddEditUserFormComponent) {
      this.addEditUserForm.reset();
    }
  }

  public show() {
    super.show();
    this.errMessage = '';
    if (this.addEditUserForm instanceof AddEditUserFormComponent) {
      this.addEditUserForm.reset();
    }
    this.refresh();
  }

  // private
  private refresh() {
    if (this.data.user_id) {
      this.userId = this.data.user_id;

      this.profileInfoService.fetchPermissions(this.brandService.getBrand(), this.userId)
        .subscribe( (permissions: any) => {
          if (this.addEditUserForm instanceof AddEditUserFormComponent) {
            this.addEditUserForm.updateFormPermissions(permissions);
          }
          this.ref.markForCheck();
        });
    } else if (this.data.invite_id) {
        this.inviteUserService.fetch(this.brandService.getBrand(), this.data.invite_id)
          .subscribe( (invite: any) => {
            if (this.addEditUserForm instanceof AddEditUserFormComponent) {
              this.addEditUserForm.updateFormInvite(invite);
            }
            this.ref.markForCheck();
          });
    }
  }
}
